/**
 * bundle-variant-titles.js
 *
 * Applies custom display titles from the custom.display_title metafield
 * to the product page and cart drawer without modifying product data.
 *
 * Theme: Aramore Custom
 * Variant selection: .swatches label[var_id] (NOT standard radio inputs)
 */

(function () {
  'use strict';

  const DATA_ISLAND_ID = 'bundle-variant-titles-data';

  const SEL = {
    swatchLabel:        '.swatches[var_id]',
    activeSwatchLabel:  '.swatches.active[var_id]',
    hiddenVariantInput: 'input[name="id"][data-productid]',
    stickySelect:       '.var-dropdown select[name="id"]',
    variantTitleTarget: '[data-bundle-variant-title]',
    cartDrawerRoot:     '#cart-drawer, #CartDrawer, [data-cart-drawer], .cart-drawer-items',
    cartItem:           '.cart-drawer-item[data-cart-item]',
    cartItemTitle:      '.cart-drawer-item--variant-title',
  };

  function loadTitleMap() {
    const island = document.getElementById(DATA_ISLAND_ID);
    if (!island) return {};
    try {
      return JSON.parse(island.textContent) || {};
    } catch (e) {
      console.warn('[bundle-variant-titles] Could not parse title data.', e);
      return {};
    }
  }

  function getDisplayTitle(titleMap, variantId) {
    return titleMap[String(variantId)] || null;
  }

  function emitTitleUpdated(variantId, displayTitle) {
    document.dispatchEvent(
      new CustomEvent('bundle:variant-title-updated', {
        bubbles: true,
        detail: { variantId, displayTitle },
      })
    );
  }

  function applyAllSwatchLabels(titleMap) {
    document.querySelectorAll('.swatches[var_id]').forEach((swatch) => {
      const variantId = swatch.getAttribute('var_id');
      const title = getDisplayTitle(titleMap, variantId);
      if (title) {
        swatch.textContent = title;
      }
    });
  }
  function applyCollectionSwatchLabels(titleMap) {
    document.querySelectorAll('.product-car-variant span[value]').forEach((span) => {
      const variantId = span.getAttribute('value');
      const title = getDisplayTitle(titleMap, variantId);
      if (title) {
        span.textContent = title;
        span.setAttribute('title', title);
      }
    });
  }

  function applyProductTitle(titleMap, variantId) {
    const title = getDisplayTitle(titleMap, variantId);
    if (!title) return;

    const titleEl = document.querySelector(SEL.variantTitleTarget);
    if (titleEl) {
      titleEl.textContent = title;
      titleEl.setAttribute('aria-label', title);
    }

    emitTitleUpdated(variantId, title);
  }

  function initProductPage(titleMap) {
    applyAllSwatchLabels(titleMap);

    const activeSwatch = document.querySelector(SEL.activeSwatchLabel);
    if (activeSwatch) {
      applyProductTitle(titleMap, activeSwatch.getAttribute('var_id'));
    }

    document.addEventListener('click', (e) => {
      const swatch = e.target.closest(SEL.swatchLabel);
      if (!swatch) return;
      requestAnimationFrame(() => {
        const variantId = swatch.getAttribute('var_id') ||
                          document.querySelector(SEL.hiddenVariantInput)?.value;
        if (variantId) applyProductTitle(titleMap, variantId);
      });
    });

    const stickySelect = document.querySelector(SEL.stickySelect);
    if (stickySelect) {
      stickySelect.addEventListener('change', (e) => {
        applyProductTitle(titleMap, e.target.value);
      });
    }

    const hiddenInput = document.querySelector(SEL.hiddenVariantInput);
    if (hiddenInput) {
      const observer = new MutationObserver(() => {
        if (hiddenInput.value) applyProductTitle(titleMap, hiddenInput.value);
      });
      observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  function patchCartItems(titleMap) {
    document.querySelectorAll(SEL.cartItem).forEach((item) => {
      const variantId = item.dataset.id;
      if (!variantId) return;

      const displayTitle = getDisplayTitle(titleMap, variantId);
      if (!displayTitle) return;

      const titleEl = item.querySelector(SEL.cartItemTitle);
      if (!titleEl) return;

      if (!titleEl.dataset.originalTitle) {
        titleEl.dataset.originalTitle = titleEl.textContent.trim();
      }
      titleEl.textContent = displayTitle;
    });
  }

  function initCartDrawer(titleMap) {
    patchCartItems(titleMap);

    ['cart:updated', 'cart:refresh', 'cart:open', 'cart-drawer:open'].forEach((evt) => {
      document.addEventListener(evt, () => {
        patchCartItems(titleMap);
        setTimeout(() => patchCartItems(titleMap), 300);
      });
    });

    // Observe attributes on <cart-drawer> — this is how the theme signals when it opens.
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      new MutationObserver(() => {
        patchCartItems(titleMap);
        setTimeout(() => patchCartItems(titleMap), 100);
      }).observe(cartDrawerEl, { attributes: true });
    }

    // Fallback: also observe changes in the items.
    const drawerRoot = document.querySelector('.cart-drawer-items');
    if (drawerRoot) {
      new MutationObserver(() => {
        patchCartItems(titleMap);
      }).observe(drawerRoot, { childList: true, subtree: true });
    }
  }

  function init() {
    const titleMap = loadTitleMap();
    if (!Object.keys(titleMap).length) return;

    initProductPage(titleMap);
    initCartDrawer(titleMap);
    applyCollectionSwatchLabels(titleMap); 
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();